<navbar></navbar>
<div style="background-color: #f7f7f7">
  <div class="container">
    <div class="hero progress" *ngIf="!mobile"></div>
    <app-progress-bar *ngIf="!mobile" value="33"></app-progress-bar>
    <app-notification *ngIf="this.errorMsg != null" [content]="this.errorMsg" (notificationClosed)="this.errorMsg = null" timeOut="0" display="true"
                      error=true></app-notification>
    <div>
      <h3 class="title is-5" *ngIf="properties.length>0">Hinzugefügte Objekte</h3>
      <ul>
        <li  *ngFor="let property of properties" style="display: inline; margin-right: 20px" [ngClass]="{'disabled' : isMapLoading}">
          <a [ngClass]="{'active': isPropertyLoaded(property)}" (click)="onPropertySelection(property)">
              {{ property.name && property.name.trim() ? property.name : property.street + ', ' + property.town }}
          </a>
          <a (click)="removePropertyFromPropertyList(property)" style="color: red"> X</a>
        </li>
      </ul>
    </div>

    <app-notification *ngIf="showMissingPropertyError" (notificationClosed)="showMissingPropertyError = false"
                      content="Bitte wählen Sie ein Objekt aus, oder geben Sie korrekte Daten für ein neues Objekt ein."
                      ignoreOffset="true" timeOut="0" display="true" error=true>
    </app-notification>
    <app-notification *ngIf="!isAllowedToOrder"
                      content="Sie haben nicht die erforderlichen Berechtigungen, um Bestellungen innerhalb dieser Gesellschaft aufzugeben."
                      [locked]="true" display="true" ignoreOffset="true" error="true" timeOut="0">
    </app-notification>
    <div class="container is-widescreen">

      <div class="columns">
        <div class="column has-text-centered is-flex is-justify-content-center">
          <div class="tabs has-text-center is-toggle">
            <ul class="border-bottom-none">
              <li [class.is-active]="!isManualObjectDataInput" (click)="updateManualDataInput(false)">
                <a>Karte</a>
              </li>
              <li [class.is-active]="isManualObjectDataInput" (click)="updateManualDataInput(true)">
                <a>Manuell</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!isManualObjectDataInput">
        <div class="card has-round-border mt-3 mx-3">

          <div class="columns">
            <div class="column">
              <h3 class="title is-5 mt-3 ml-3">Grundstücksdaten</h3>
            </div>
            <div class="column is-narrow mt-3 mr-3 is-clickable" (click)="openInformationModal(true)">
              <fa-icon class="color-lightblue" [icon]="faQuestionCircle"></fa-icon>
            </div>
          </div>

          <form [formGroup]="propertyInformationForm">
            <div class="columns">
              <div class="column is-one-third ml-3">
                <div class="inputfield">
                  <input formControlName="name" name="name" type="text" class="border-input" placeholder="Objektname (optional)"
                         [ngClass]="{'has-error': FormUtils.hasError(propertyInformationForm.get('name'))}"/>
                  <small *ngIf="propertyInformationForm.get('name').hasError('maxlength') && propertyInformationForm.get('name').touched"
                         style="color: red; font-size: 10px;">
                    Maximale Zeichenanzahl überschritten
                  </small>
                </div>
              </div>
            </div>
          </form>

          <div class="columns">
            <div class="column">
              <app-parcel-map (updateProperty)="updatePropertyFromMap($event)" (updateMapData)="updateMapData()" (filterPropertyFoliosByParcels)="filterPropertyFoliosByParcels($event)"></app-parcel-map>
            </div>
          </div>
          <div *ngIf="property && hasFullAddress" class="columns">
            <div class="column is-narrow">
              <div class="ml-2 mb-3">
                <fa-icon [icon]="faBuilding"></fa-icon>
                <span class="ml-3">{{property.street}} {{property.house_number}} , {{property.zip}} {{property.town}}</span>
              </div>
            </div>

            <div class="column">
              <div class="columns mb-3" *ngFor="let folio of property.landregisterfolios">
                <div class="column">
                  <b>Gemarkung: </b> {{ folio.gemarkung ?? "-" }}
                  <b>Flur:</b> <span *ngFor="let flur of folio.flure">{{ flur.number ?? "-" }} <b>Flurstücke:</b> <span
                    *ngFor="let fs of flur.flurstuecke">{{ fs.number ?? "-" }}, </span></span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </ng-container>



      <div [ngClass]="(isManualObjectDataInput)?'is-block':'is-hidden'" (mouseleave)="checkPropertyInFormManually()">
        <div class="column mt-3 ml-3 mr-3 card has-round-border" style="box-shadow: 0 4px 5px 2px rgba(0, 0, 0, 0.3);">
          <h3 class="title is-5">Grundstücksdaten</h3>
          <app-property-form [property]="property" [toNextPage]="toNextPage" [showCheckbox]="true" [disabled]="!isAllowedToOrder" [shouldDisplayFolioNumber]="false"></app-property-form>
        </div>
      </div>

      <div *ngIf="isManualObjectDataInput" class="card has-round-border mt-5 mx-3 p-3">
        <div class="warning-container my-4">
          <span class="is-bold color-darkblue">Wichtig:</span> Bei der manuellen Eingabe der Grundstücksdaten wird unser
          Qualitätsservice in Höhe von {{ researchAmount | currency: 'EUR'}} verpflichtend dazu gebucht.
        </div>
      </div>

      <div class="column mx-3 my-3 card has-round-border">
        <p class="title is-5 is-bold">Jetzt noch schneller: Flurstücke direkt auf der Karte anklicken.</p>
        <p class="is-5"><b>Schnell und einfach:</b> Adresse eingeben und die zugehörigen Flurstücke direkt auf der Karte anklicken (Mehrfachauswahl möglich).</p>
        <div class="warning-container-white-background my-2">
          <p>
            <span class="is-bold color-darkblue">Wichtig:</span> Bitte nur Flurstücke auswählen, für die ein berechtigtes Interesse besteht.
            Unberechtigte Anfragen werden abgelehnt, verursachen ggf. Mehrkosten und verzögern die Bearbeitung.
          </p>
        </div>
        <p class="mb-1">
          Unsicher? Buchen Sie einfach unseren Rechercheservice – wir kümmern uns um die korrekten Angaben.
        </p>
        <p>
          <span class="is-bold">Alternative Eingabe:</span>
          Flurstücke manuell eingeben – der Rechercheservice wird automatisch aktiviert und wir prüfen Ihre Angaben.
        </p>
      </div>

      <div class="column mt-5 mx-3 card has-round-border">
        <form [formGroup]="propertyInformationForm">

          <p class="title is-5 is-bold">Sie sind sich bei den Grundstücksdaten nicht ganz sicher?</p>

          <p>Kein Problem - mit unserem Recherche-Service übernehmen wir für Sie die Ermittlung der offiziellen Daten (Gemarkung, Flur, Flurstück und ggf. Grundbuchblatt) direkt bei den zuständigen Stellen.</p>
          <p>
            <span class="is-bold">Empfohlen zur Qualitätssicherung:</span>
            So stellen wir sicher, dass Ihre Anfrage eindeutig und vollständig ist - und Verzögerungen bei der Bearbeitung vermieden werden.
          </p>
          <div class="field mt-4">
            <div class="control promoted-checkbox">
              <input id="tmp" class="promoted-input-checkbox" type="checkbox" formControlName="dataResearch"/>
              <label for="tmp"
                     class="custom-checkbox-label is-size-6"
                     matTooltip="Bei der manuellen Eingabe der Grundstücksdaten ist die Qualitätskontrolle verpflichtend."
                     [matTooltipDisabled]="!propertyInformationForm.get('dataResearch')?.disabled">
                <img class="checkbox-icon" alt="Checkbox icon" [src]="propertyInformationForm.get('dataResearch')?.value ? 'assets/images/checkbox/checked.svg' : 'assets/images/checkbox/unchecked.svg'"/><span>
                Ich möchte, dass DocEstate die Grundstücksdaten gegen einen Aufpreis von
                <span *ngIf="researchAmount">
                  {{ researchAmount | currency: 'EUR' }}
                </span>
                für mich recherchiert.
              </span>
              </label>
            </div>
          </div>
        </form>
      </div>

      <div id="property-container" [ngClass]="{'is-invisible': extraDocuments}">
        <app-products-container [isConnectOrigin]="false" (infoRequest)="displayInfoEvent($event)"
                                (checkProperty)="checkIfPropertyIsSelected()"
                                (mouseenter)="checkPropertyInFormManually()"
                                (getSelectedProperty)="getSelectedProperty()" [user]="user"
                                (updatePropertyForm)="updatePropertyForm()"
                                [isAllowedToOrder]="isAllowedToOrder"></app-products-container>
      </div>

      <div class="columns" *ngIf="!mobile">
        <div class="column is-3" [ngClass]="{'disabled': isMapLoading}">
          <a (click)="addAuthority(false)" class="button back-button is-size-6 has-round-border" style="border:none;display: block !important;">
            <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
              <div class="column">
                <p class="is-bold" style="padding-bottom: 10px;">Weiteres Objekt hinzufügen</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column is-6"></div>
        <div class="column is-3">
            <a (click)="handleAddAuthorityClickEvent($event)"
               [ngClass]="{'disabled': !checkIfAllProductInformationArePresent()}"
               class="button buy-button is-size-6 has-round-border" style="border:none; display: block!important;">
            <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
              <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px">Weiter</p></div>
              <div class="column is-one-fifth">
                <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="columns is-mobile" *ngIf="mobile" style="margin: 5%">
        <div class="column is-3"></div>
        <div class="column is-6">
          <button class="button is-blue" (click)="isAllowedToOrder ? addAuthority(true) : scrollToNotification()">Weiter</button>
        </div>
        <div class="column is-3"></div>
      </div>
    </div>
  </div>

  <app-modal id="support-modal" [active]="showContactSupportModal" (modalClosed)="showContactSupportModal = false;" [closeable]="false">
    <div class="title is-5">Überprüfung des Kontos</div>
    <p>Ihr Konto wird momentan noch von uns geprüft.</p>
    <p>Bei Fragen melden Sie sich gerne über das Kontaktformular, oder gehen Sie zurück zur Homepage.</p>
    <p>&nbsp;</p>
    <div class="columns">
      <div class="column is-half">
        <app-button content="Zurück zur Homepage" cancel="true" routerLink="/home"></app-button>
      </div>
      <div class="column is-half">
        <button class="button is-blue" (click)="setShowContactForm()">Kontakt aufnehmen</button>
      </div>
    </div>
    <app-contact-overlay [displayed]="showContactForm" (modalClosed)="showContactForm=false"></app-contact-overlay>
  </app-modal>
</div>


<app-modal [active]="displayInfo" (modalClosed)="displayInfo = false">
  <p  [innerHTML]="docInfo | safeHtml"></p>
</app-modal>
